export const gridsType = {
  performance: 'performance',
  smartPerformance: 'smartPerformance',
  budget: 'budget',
  management: 'management',
  import: 'import',
};

export const gridsMap = {
  [gridsType.performance]: {
    gridName: 'PerformanceGrid',
    el: '.performanceGrid',
    tableNameLocalizedKey: 'AccountDashboard_PerformanceTab',
  },
  [gridsType.smartPerformance]: {
    gridName: 'SmartPerformanceGrid',
    el: '.smartPerformanceGrid',
    tableNameLocalizedKey: 'AccountDashboard_SmartPerformanceTab',
  },
  [gridsType.budget]: {
    gridName: 'BudgetGrid',
    el: '.budgetGrid',
    tableNameLocalizedKey: 'AccountDashboard_BudgetTab',
  },
  [gridsType.management]: {
    gridName: 'ManagementGrid',
    el: '.budgetGrid',
    tableNameLocalizedKey: 'AccountDashboard_BudgetManagementTab',
  },
  [gridsType.import]: {
    gridName: 'ImportGrid',
    el: '.importGrid',
    tableNameLocalizedKey: 'AccountDashboard_ImportTab',
  },
};

export const EmptyColumnValue = '-';
